import { statusOf, type UserRow } from "./types";

/** "Active" in green or "Deactivated" in grey: the word carries it, the dot only echoes it. */
export function StatusLabel({ user }: { user: UserRow }) {
  const active = statusOf(user) === "active";
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[13px] ${active ? "text-success" : "text-muted"}`}
    >
      <span aria-hidden className={`size-1.5 rounded-full ${active ? "bg-success" : "bg-dim"}`} />
      {active ? "Active" : "Deactivated"}
    </span>
  );
}
